<template>
    <div class="detail-footer" ref="footer">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'ab-footer',
    data () {
        return {

        }
    },
    mounted () {
    //     setTimeout(() => {
    //         var box = document.getElementsByClassName('tankage')[0]
    //         var footer = this.$refs.footer
    //    //     footer.style.bottom = '-20px'
    //         console.log(box)
    //         console.log(footer)
    //         box.addEventListener('scroll', function() {
    //             var scrollHight = box.scrollHeight;
    //             var clientHeight = box.clientHeight;
    //             var scrollTop = box.scrollTop;
            
    //             if (scrollTop + clientHeight == scrollHight) {
    //                 console.log('daodile')
    //             }
    //         })
    //     },50)
    }
}
</script>

<style lang="scss">
.detail-footer {
  position: sticky;
  bottom: -20px;
  width: 100%;
  background-color: #ffffff;
  z-index: 998;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  border-top: 1px solid #F0F2F5;
}
</style>